<div class="part-container" (click)="onClick()">
  <div class="background" [ngStyle]="backgroundStyle"></div>

  @if (avatarPart) {
    <div class="image-container">
      <img class="part-image" [src]="partUrl" />
    </div>
  }

  @if (!avatarPart) {
    <div class="icon-container">
      <i class="material-icons">block</i>
    </div>
  }

  @if (avatarPart && !avatarPart.usable) {
    <div [ngStyle]="priceBoxStyle" class="price-box">
      <app-user-economy
        [amount]="avatarPart.price"
        [mode]="selected ? 'light' : 'dark'"
      ></app-user-economy>
    </div>
  }
</div>
